// src/components/vendor/TopProducts.jsx
import React from 'react';
import {
  Paper,
  Typography,
  Stack,
  Avatar,
  Box,
  LinearProgress,
  Button,
} from '@mui/material';
import { TrendingUp, Star } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TopProducts = ({ products = [] }) => {
  const navigate = useNavigate();

  const getProgressColor = (index) => {
    const colors = ['primary', 'secondary', 'success', 'warning', 'info'];
    return colors[index % colors.length];
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <TrendingUp color="primary" />
          <Typography variant="h6" fontWeight="bold">
            Top Products
          </Typography>
        </Stack>
        <Button size="small" onClick={() => navigate('/vendor/analytics')}>
          View All
        </Button>
      </Stack>

      <Stack spacing={2}>
        {products.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography color="text.secondary">
              No product data available
            </Typography>
          </Box>
        ) : (
          products.slice(0, 5).map((product, index) => {
            const maxSales = products[0]?.sales || 1;
            const progress = (product.sales / maxSales) * 100;

            return (
              <Box key={index}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar
                    variant="rounded"
                    src={product.thumbnail}
                    sx={{ width: 40, height: 40 }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="body2" fontWeight="600">
                        {product.name || 'Unknown'}
                      </Typography>
                      <Typography variant="body2" fontWeight="600" color="primary">
                        {product.sales || 0} sales
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <LinearProgress
                        variant="determinate"
                        value={progress}
                        color={getProgressColor(index)}
                        sx={{ flex: 1, height: 6, borderRadius: 3 }}
                      />
                      <Typography variant="caption" color="text.secondary">
                        {Math.round(progress)}%
                      </Typography>
                    </Stack>
                  </Box>
                </Stack>
              </Box>
            );
          })
        )}
      </Stack>
    </Paper>
  );
};

export default TopProducts;